module.exports = __webpack_public_path__ + "img/error_icon.fba26098.png";